import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { IWorkOrderLifecycle } from "@/data/work-orders";
import { Flex } from "@/eworkitComponents/components";
import { useFormats } from "@/hooks/Formats";
import { List, ListItem } from "@/views/components/List";

export interface IWorkOrderDetailsLifecycleListProps {
  lifecycles: IWorkOrderLifecycle[];
}

export const WorkOrderDetailsLifecycleList: FC<IWorkOrderDetailsLifecycleListProps> = memo(({ lifecycles }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();

  return (
    <List innerShadows={false}>
      {lifecycles.map(lifecycle => (
        <ListItem key={lifecycle.id}>
          <Flex direction="column" innerMargin="xs">
            <Flex innerMargin="sm">
              <Flex width={6}>
                <Text color="grey2">{t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.ACTIVITY_TYPE_TABLE_HEADER")}</Text>
              </Flex>

              <Flex width={6}>
                <Flex innerMargin="sm">
                  <Icon icon="checkbox" size="md" />
                  <Text wordBreak="word" whiteSpace="pre-wrap">
                    {t(`WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.ACTIVITY_TYPE.${lifecycle.activityType}`, {
                      username: lifecycle.arg1,
                    })}
                  </Text>
                </Flex>
              </Flex>
            </Flex>

            {["TASK_APPROVED", "TASK_REJECTED"].includes(lifecycle.activityType) && lifecycle.arg1 && (
              <Flex innerMargin="sm">
                <Flex width={6}>
                  <Text color="grey2">{t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.WHO_TABLE_HEADER")}</Text>
                </Flex>

                <Flex width={6}>{lifecycle.arg1}</Flex>
              </Flex>
            )}

            <Flex innerMargin="sm">
              <Flex width={6}>
                <Text color="grey2">{t("WORK_ORDERS.DETAILS.LIFECYCLE_DETAILS.WHEN_TABLE_HEADER")}</Text>
              </Flex>

              <Flex width={6}>{formatDate(lifecycle.createdDate)}</Flex>
            </Flex>
          </Flex>
        </ListItem>
      ))}
    </List>
  );
});
